export const Credits = ({ dark }) => (
  <p data-testid="footer-credits" className={`text-[11px] leading-relaxed text-right ${dark ? "text-zinc-500" : "text-zinc-400"}`}>
    Copyright © GWD - Grafica Web Design ~ 2026 Powered by Pixaweb sagl -{" "}
    <a href="mailto:info@graficawebdesign.com" className="underline-offset-2 hover:underline hover:text-[#0D9488]">info@graficawebdesign.com</a> -{" "}
    <a href="https://www.graficawebdesign.com" target="_blank" rel="noopener noreferrer" className="underline-offset-2 hover:underline hover:text-[#0D9488]">www.graficawebdesign.com</a>
  </p>
);

export const Footer = () => (
  <footer className="border-t border-zinc-200 bg-white">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-5 flex justify-end">
      <Credits />
    </div>
  </footer>
);
